import {analyticsLogger} from 'analytics/analyticsLogger';

type ExecSponsorInboxInteraction =
  | {
      action: 'search_used';
      queryLength: number;
      resultCount: number;
    }
  | {
      action: 'workstream_opened' | 'workstream_selected';
    }
  | {
      action: 'section_toggled';
      section: 'needs_resolution' | 'readiness' | 'reviewed';
      isExpanded: boolean;
    }
  | {
      action: 'view_more';
      section: 'unread' | 'reviewed';
      visibleItemCount: number;
      totalItemCount: number;
    }
  | {
      action: 'launch_doc_opened' | 'marked_reviewed';
      itemType: string;
      outcomeType?: string | null;
    };

export const logExecSponsorInboxInteraction = (interaction: ExecSponsorInboxInteraction) => {
  if (interaction.action === 'search_used') {
    analyticsLogger().logEvent('EXEC_SPONSOR_INBOX_INTERACTION', {
      action: interaction.action,
      query_length: interaction.queryLength,
      result_count: interaction.resultCount,
    });
    return;
  }

  if (interaction.action === 'launch_doc_opened' || interaction.action === 'marked_reviewed') {
    analyticsLogger().logEvent('EXEC_SPONSOR_INBOX_INTERACTION', {
      action: interaction.action,
      item_type: interaction.itemType,
      outcome_type: interaction.outcomeType ?? undefined,
    });
    return;
  }

  if (interaction.action === 'section_toggled') {
    analyticsLogger().logEvent('EXEC_SPONSOR_INBOX_INTERACTION', {
      action: interaction.action,
      section: interaction.section,
      is_expanded: interaction.isExpanded,
    });
    return;
  }

  if (interaction.action === 'view_more') {
    analyticsLogger().logEvent('EXEC_SPONSOR_INBOX_INTERACTION', {
      action: interaction.action,
      section: interaction.section,
      visible_item_count: interaction.visibleItemCount,
      total_item_count: interaction.totalItemCount,
    });
    return;
  }

  analyticsLogger().logEvent('EXEC_SPONSOR_INBOX_INTERACTION', {
    action: interaction.action,
  });
};

export const logExecSponsorInboxWorkstreamViewed = ({
  readinessScore,
  needsResolutionCount,
  overdueMilestoneCount,
  unreadReviewItemTypes,
  unreadReviewItemCount,
  allReviewItemCount,
}: {
  readinessScore: string | null | undefined;
  needsResolutionCount: number;
  overdueMilestoneCount: number;
  unreadReviewItemTypes: string[];
  unreadReviewItemCount: number;
  allReviewItemCount: number;
}) => {
  analyticsLogger().logEvent('EXEC_SPONSOR_INBOX_WORKSTREAM_VIEWED', {
    readiness_score: readinessScore?.toLocaleLowerCase() ?? 'not_scored',
    needs_resolution_count: needsResolutionCount,
    overdue_milestone_count: overdueMilestoneCount,
    unread_review_item_types: unreadReviewItemTypes,
    unread_review_item_count: unreadReviewItemCount,
    all_review_item_count: allReviewItemCount,
  });
};
